export const calculateLatestOrder = order => {
  const relatedOrders = order?.relatedOrders;

  const reconditioningOrder = relatedOrders?.find(
    item => item?.orderType === 'reconditioning'
  );

  const latestOrder = reconditioningOrder?.arrivedOn;

  return latestOrder ?? null;
};
